import React from "react";
import { useSubmitProduct } from "./useSubmitProduct";
import { Redirect } from "react-router";
import Loading from "../Loading";
import { Container, Row, Col } from "react-bootstrap";

const SubmitProduct = ({ formData }) => {
  const { restart } = useSubmitProduct({ formData });

  if (restart) {
    return (
      <Container>
        <Row>
          <Col>
            <Loading />
          </Col>
        </Row>
      </Container>
    );
  } else {
    return <Redirect to="/products" />;
  }

  // console.log("CodeDeploy form: ", formData);
  // console.log("Data Records: ", datarecords);
};

export default SubmitProduct;
